export enum EmailType {
	RESERVATION_CANCEL_AGREEMENT = 'reservation_cancel_agreement',
	RESERVATION_CHANGED_AGREEMENT = 'reservation_changed_agreement',
	RESERVATION_CANCEL = 'reservation_cancel',
	RESERVATION_PAYMENT_REMIND = 'reservation_payment_remind',
	RESERVATION_CONFIRM_MAIL = 'reservation_confirm_mail',
	RESERVATION_CONFIRM_MAIL_FOR_AGENT = 'reservation_confirm_mail_for_agent',
	DOK_TO_SGL_MAIL = 'dok_to_sgl_mail',
	DOK_TO_SGL_MAIL_FOR_AGENT = 'dok_to_sgl_mail_for_agent',
	DEPARTURE_CITY_WITHDRAWN = 'departure_city_withdrawn_mail',
	DEPARTURE_CITY_WITHDRAWN_FOR_AGENT = 'departure_city_withdrawn_mail_for_agent',
}
